<template>
  <el-dialog title="会话归档" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <div class="list-box" v-for="(item,index) in archiveOptions" :key="index">
      <span class="title">{{item.title}}：</span>
      <div class="list">
        <el-tag v-for="(it,idx) in item.tags" :key="idx" :type="it.active?'':'info'" effect="plain" @click="handleContent(it,index)">{{ it.title }}</el-tag>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceArchiveGroupApi from '@/api/customer/custServiceArchiveGroup'
import imConversationApi from '@/api/customer/imConversation'
export default {
  props: ['currentUser'],
  data() {
    return {
      form: null,
      formVisible: false,
      archiveOptions: []

    }
  },
  created() {

  },
  methods: {
    handleShow() {
      this.getArchiveList()
    },
    getArchiveList() {
      custServiceArchiveGroupApi.fetchForList({ isGetTag: true }).then(({ data }) => {
        this.archiveOptions = data;
        this.formVisible = true;
      })
    },
    handleContent(it) {
      this.rowData = it
      this.archiveOptions.forEach(ab => {
        ab.tags.forEach(cc => {
          cc.active = false;
        })
      })
      it.active = true;
      this.$forceUpdate()
    },
    // 归档
    doCreate() {
      imConversationApi.setEnd({
        archiveTagId: this.rowData.id,
        id: this.currentUser.id
      }).then(() => {
        this.$emit('created');
        this.formVisible = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list-box {
  margin-bottom: 18px;
  .list {
    display: inline-block;
    .el-tag {
      margin-right: 18px;
      cursor: pointer;
    }
  }
}
</style>
